import { removeStyleTag, upsertStyleTag } from "../../domStyles";

const STYLE_ID = "incluway-pause-animations-style";
const EXCLUDE = "#incluway-widget-root";

export function enablePauseAnimations() {
  upsertStyleTag(
    STYLE_ID,
    `
*:not(${EXCLUDE}):not(${EXCLUDE} *) {
  animation-play-state: paused !important;
  transition: none !important;
}
`.trim(),
  );
}

export function disablePauseAnimations() {
  removeStyleTag(STYLE_ID);
}
